import * as i0 from '@angular/core';
import { input, output, Component, ChangeDetectionStrategy, inject, numberAttribute, model, computed, booleanAttribute } from '@angular/core';
import { SHARE_BUTTONS_CONFIG, SHARE_BUTTONS } from 'ngx-sharebuttons';
import { ShareButton } from 'ngx-sharebuttons/button';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
function ShareButtons_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "share-button", 2);
    i0.ɵɵlistener("opened", function ShareButtons_For_2_Template_share_button_opened_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.opened.emit($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const button_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("button", button_r3)("theme", ctx_r1.theme())("url", ctx_r1.url())("title", ctx_r1.title())("description", ctx_r1.description())("image", ctx_r1.image())("tags", ctx_r1.tags())("redirectUrl", ctx_r1.redirectUrl())("showIcon", ctx_r1.showIcon())("showText", ctx_r1.showText())("disabled", ctx_r1.disabled());
  }
}
function ShareButtons_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "expand-button", 3);
    i0.ɵɵtwoWayListener("expandChange", function ShareButtons_Conditional_3_Template_expand_button_expandChange_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.expanded, $event) || (ctx_r1.expanded = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(i0.ɵɵinterpolate1("sb-button sb-", ctx_r1.theme()));
    i0.ɵɵproperty("options", ctx_r1.options);
    i0.ɵɵtwoWayProperty("expand", ctx_r1.expanded);
  }
}
let ExpandButton = /*#__PURE__*/(() => {
  class ExpandButton {
    constructor() {
      this.options = input();
      this.expand = input();
      this.expandChange = output();
    }
    static {
      this.ɵfac = function ExpandButton_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ExpandButton)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ExpandButton,
        selectors: [["expand-button"]],
        inputs: {
          options: [1, "options"],
          expand: [1, "expand"]
        },
        outputs: {
          expandChange: "expandChange"
        },
        decls: 4,
        vars: 2,
        consts: [[1, "sb-wrapper", "sb-expand", "sb-show-icon", 3, "click"], [1, "sb-content"], [1, "sb-icon"], [3, "icon"]],
        template: function ExpandButton_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵlistener("click", function ExpandButton_Template_button_click_0_listener() {
              return ctx.expandChange.emit(!ctx.expand());
            });
            i0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
            i0.ɵɵelement(3, "fa-icon", 3);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵattribute("aria-label", ctx.expand() ? ctx.options().lessButtonAriaLabel : ctx.options().moreButtonAriaLabel);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("icon", ctx.expand() ? ctx.options().lessButtonIcon : ctx.options().moreButtonIcon);
          }
        },
        dependencies: [FaIconComponent],
        styles: ["[button=facebook][_nghost-%COMP%], [button=facebook]   [_nghost-%COMP%]{--button-color: #4267B2}[button=x][_nghost-%COMP%], [button=x]   [_nghost-%COMP%]{--button-color: #00acee}[button=mix][_nghost-%COMP%], [button=mix]   [_nghost-%COMP%]{--button-color: #ff8226}[button=line][_nghost-%COMP%], [button=line]   [_nghost-%COMP%]{--button-color: #00b900}[button=linkedin][_nghost-%COMP%], [button=linkedin]   [_nghost-%COMP%]{--button-color: #0a66c2}[button=pinterest][_nghost-%COMP%], [button=pinterest]   [_nghost-%COMP%]{--button-color: #bd081c}[button=reddit][_nghost-%COMP%], [button=reddit]   [_nghost-%COMP%]{--button-color: #ff4006}[button=tumblr][_nghost-%COMP%], [button=tumblr]   [_nghost-%COMP%]{--button-color: #36465d}[button=whatsapp][_nghost-%COMP%], [button=whatsapp]   [_nghost-%COMP%]{--button-color: #25d366}[button=messenger][_nghost-%COMP%], [button=messenger]   [_nghost-%COMP%]{--button-color: #0080FF}[button=telegram][_nghost-%COMP%], [button=telegram]   [_nghost-%COMP%]{--button-color: #0088cc}[button=xing][_nghost-%COMP%], [button=xing]   [_nghost-%COMP%]{--button-color: #006567}[button=sms][_nghost-%COMP%], [button=sms]   [_nghost-%COMP%]{--button-color: #20c16c}[button=email][_nghost-%COMP%], [button=email]   [_nghost-%COMP%]{--button-color: #FF961C}[button=viber][_nghost-%COMP%], [button=viber]   [_nghost-%COMP%]{--button-color: #665ca7}[button=vk][_nghost-%COMP%], [button=vk]   [_nghost-%COMP%]{--button-color: #4C75A3}[button=copy][_nghost-%COMP%], [button=copy]   [_nghost-%COMP%]{--button-color: #607D8B}[button=print][_nghost-%COMP%], [button=print]   [_nghost-%COMP%]{--button-color: #765AA2}[button=expand][_nghost-%COMP%], [button=expand]   [_nghost-%COMP%]{--button-color: #FF6651}button[_ngcontent-%COMP%]{cursor:pointer;position:relative;outline:0;-webkit-print-color-adjust:exact;margin:var(--sb-margin, .3125em);padding:var(--sb-padding, 0);min-width:var(--sb-min-width, 4.125em);height:var(--sb-height, 2.5em);color:var(--sb-color, #fff);background:var(--sb-background);font-size:var(--sb-font-size, 13px);line-height:var(--sb-line-height, 2.571em);border:var(--sb-border);border-radius:var(--sb-border-radius);transition:var(--sb-transition);box-shadow:var(--sb-box-shadow);text-shadow:var(--sb-text-shadow);overflow:var(--sb-overflow)}.sb-icon[_ngcontent-%COMP%], .sb-text[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;-webkit-user-select:none;user-select:none}.sb-content[_ngcontent-%COMP%]{flex:1;display:flex;height:100%;width:100%;position:relative}.sb-text[_ngcontent-%COMP%]{flex:1;height:100%;white-space:nowrap;padding:var(--sb-text-padding, 0 .7em);font-weight:var(--sb-font-weight, bold)}.sb-icon[_ngcontent-%COMP%]{text-align:center;width:100%;height:100%;min-width:2em;font-size:var(--sb-icon-size, 1.2em)}", "[_nghost-%COMP%]{--button-color: var(--sb-expand-button-color, #FF6651)}"],
        changeDetection: 0
      });
    }
  }
  return ExpandButton;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ShareButtons = /*#__PURE__*/(() => {
  class ShareButtons {
    constructor() {
      /** Global default options */
      this.options = inject(SHARE_BUTTONS_CONFIG);
      /** Numbers of buttons to show */
      this.show = input(Object.values(SHARE_BUTTONS).length, {
        transform: numberAttribute
      });
      /** Array of included buttons */
      this.include = input(this.options.include || []);
      /** Array of excluded buttons */
      this.exclude = input(this.options.exclude || []);
      this.expanded = model(false);
      this.selectedButtons = computed(() => {
        const includedButtons = this.include().length ? this.include() : Object.keys(SHARE_BUTTONS);
        return includedButtons.filter(btn => this.exclude().indexOf(btn) < 0);
      });
      this.displayButtons = computed(() => {
        const selectedButtons = this.selectedButtons();
        return selectedButtons.slice(0, this.expanded() ? selectedButtons.length : this.show());
      });
      this.theme = input(this.options.theme);
      /** The sharing link */
      this.url = input();
      /** The title parameter */
      this.title = input();
      /** The description parameter */
      this.description = input();
      /** The image parameter for sharing on Pinterest */
      this.image = input();
      /** The tags parameter for sharing on X and Tumblr */
      this.tags = input();
      /** Sets the fb messenger redirect url to enable sharing on Messenger desktop */
      this.redirectUrl = input();
      /** Show buttons icons */
      this.showIcon = input(true, {
        transform: booleanAttribute
      });
      /** Show buttons text */
      this.showText = input(false, {
        transform: booleanAttribute
      });
      /** A flag that indicates if the button's click is disabled */
      this.disabled = input(false, {
        transform: booleanAttribute
      });
      /** Share dialog opened event */
      this.opened = output();
    }
    static {
      this.ɵfac = function ShareButtons_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ShareButtons)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ShareButtons,
        selectors: [["share-buttons"]],
        inputs: {
          show: [1, "show"],
          include: [1, "include"],
          exclude: [1, "exclude"],
          expanded: [1, "expanded"],
          theme: [1, "theme"],
          url: [1, "url"],
          title: [1, "title"],
          description: [1, "description"],
          image: [1, "image"],
          tags: [1, "tags"],
          redirectUrl: [1, "redirectUrl"],
          showIcon: [1, "showIcon"],
          showText: [1, "showText"],
          disabled: [1, "disabled"]
        },
        outputs: {
          expanded: "expandedChange",
          opened: "opened"
        },
        decls: 4,
        vars: 4,
        consts: [[3, "button", "theme", "url", "title", "description", "image", "tags", "redirectUrl", "showIcon", "showText", "disabled"], [3, "class", "options", "expand"], [3, "opened", "button", "theme", "url", "title", "description", "image", "tags", "redirectUrl", "showIcon", "showText", "disabled"], [3, "expandChange", "options", "expand"]],
        template: function ShareButtons_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div");
            i0.ɵɵrepeaterCreate(1, ShareButtons_For_2_Template, 1, 11, "share-button", 0, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵconditionalCreate(3, ShareButtons_Conditional_3_Template, 1, 5, "expand-button", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassMap(i0.ɵɵinterpolate1("sb-group sb-", ctx.theme()));
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.displayButtons());
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.show() < ctx.selectedButtons().length ? 3 : -1);
          }
        },
        dependencies: [ShareButton, ExpandButton],
        styles: ["[_nghost-%COMP%]{display:inherit}.sb-group[_ngcontent-%COMP%], .sb-button[_ngcontent-%COMP%]{display:inline-flex;align-items:flex-start}.sb-group[_ngcontent-%COMP%]{flex-wrap:wrap}"],
        changeDetection: 0
      });
    }
  }
  return ShareButtons;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { ShareButtons };
